import { createApp } from "vue";
import App from "./App.vue";
import router from "./routes/index";
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { auth } from "./plugins/firebase";
import { onAuthStateChanged } from "firebase/auth";
import {App as capApp} from '@capacitor/app';
import { signInWithCustomToken } from "firebase/auth";
import { Browser } from '@capacitor/browser';

library.add(fas);

let app;
onAuthStateChanged(auth, () => {
  if (!app) {
    app = createApp(App)
              .component('font-awesome-icon', FontAwesomeIcon)
              .provide('$router', router)
    app.use(router);
    app.mount("#app");
  }
});


capApp.addListener('appUrlOpen', function (event) {
  if (event.url.includes('chargeline://')) {
    // console.log('Deeplink geöffnet:', event.url.split("chargeline://")[0]);
    Browser.close();
    // Handle deeplink logic here
  }
  const path = event.url.split('.app').pop();

  if (path) {

    if (path.split('/').pop()) {

      signInWithCustomToken(auth, path.split('/').pop())
        .then(() => {
          router.push({ name: 'calendar' })
        })
        .catch(err => { 
          this.token = false
          console.error(err) })
    }
  }
});
